// from https://www.w3.org/TR/css-color-4/multiply-matrices.js
export default function multiplyMatrices(A, B) {
  var m = A.length;
  if (!Array.isArray(A[0])) {
    // A is vector, convert to [[a, b, c, ...]]
    A = [A];
  }
  if (!Array.isArray(B[0])) {
    // B is vector, convert to [[a], [b], [c], ...]]
    B = B.map(function (x) {
      return [x];
    });
  }
  var p = B[0].length;
  var B_cols = B[0].map(function (_, i) {
    return B.map(function (x) {
      return x[i];
    });
  }); // transpose B
  var product = A.map(function (row) {
    return B_cols.map(function (col) {
      if (!Array.isArray(row)) {
        return col.reduce(function (a, c) {
          return a + c * row;
        }, 0);
      }
      return row.reduce(function (a, c, i) {
        return a + c * (col[i] || 0);
      }, 0);
    });
  });
  if (m === 1) {
    product = product[0]; // Avoid [[a, b, c, ...]]
  }
  if (p === 1) {
    return product.map(function (x) {
      return x[0];
    }); // Avoid [[a], [b], [c], ...]]
  }
  return product;
}